import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import { FlexBoxRow } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';
import Carousel from '@ertelecom/ui-react/components/carousel';

export const ContainerSlider = styled.div`
    display: block;
    width: 1098px;
    margin: 0 auto 40px;
    @media(max-width: 1450px) {
        width: 845px;
    }
    @media(max-width: 1180px) {
        width: 560px;
    }
    @media(max-width: 765px) {
        width: 280px;
        margin: 0 auto 70px;
    }
`;

export const Counter = styled.p`
    display: none;
    margin-top: 10px;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    color: ${COLORS.darkGrey};
    margin-right: 17px;
    line-height: 24px;
    text-align: center;
`;

export const Wrapper = styled.div`
    display: flex;
    align-self: center;
`;

export const Title = styled.h1`
    margin: 30px 0 0;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-size: 32px;
    line-height: 1.32;
    font-weight: 300;
    color: ${COLORS.black};
    width: 100%;

    span {
        display:inline-block;
        width: 100%;
        font-size: 24px;
        margin-top: 40px;
        font-family: ${FONTS.regular};
    }

    @media (max-width: 530px) {
        font-size: 24px;
    }
`;

export const Subtitle = styled.span`
    display:inline-block;
    width: 100%;
    font-size: 24px;
    margin-top: 10px;
    font-family: ${FONTS.regular};
`;

export const DotWrapper = styled.div`
    align-self: center;
    z-index: 10;
    margin: -80px auto 0 20px;
`;

export const Dots = styled.div`
    width: 11px;
    height: 11px;
    border-radius: 50%;
    text-align: center;
    background: ${props => props.active ? COLORS.lightBlue : COLORS.grey};
    opacity: ${props => props.active ? 1 : 0.6};
    padding: 5px;
    margin: 0 20px 0 0;
    cursor: pointer;
    @media(min-width:767px){
        display:none;
    }
    &:hover{
        opacity: ${props => props.active ? 1 : 0.6};
        background: ${COLORS.blue}
    }

`;

export const ArrowWrapper = styled.div`
    width: calc(100% + 120px);
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: calc(50% - 32px);
    left: calc(120px / -2);
    pointer-events: none;
    z-index: 3;
    @media(max-width:767px){
        display: none;
    }
`;

export const LeftArrow = styled.div`
    position: relative;
    display: flex;
    width: 63px;
    height: 63px;
    border-radius: 100%;
    background: ${COLORS.white};
    box-shadow: 0px 0px 22px 13px rgba(0, 0, 0, 0.04), 0px 0px 13px -5px rgba(0, 0, 0, 0.13);
    cursor: pointer;
    pointer-events: auto;
    visibility: ${p => p.isHide ? 'hidden' : 'visible'};
    :before {
        content: '';
        position: absolute;
        width: 17px;
        height: 17px;
        top: 50%;
        left: 50%;
        border-left: 2px solid ${COLORS.red};
        border-bottom: 2px solid ${COLORS.red};
        border-radius: 1px;
        transform-origin: center;
        transform: translate(-30%, -50%) rotate(45deg);
    }
`;

export const RightArrow = styled.div`
    position: relative;
    display: flex;
    width: 63px;
    height: 63px;
    border-radius: 100%;
    background: ${COLORS.white};
    box-shadow: 0px 0px 22px 13px rgba(0, 0, 0, 0.04), 0px 0px 13px -5px rgba(0, 0, 0, 0.13);
    cursor: pointer;
    pointer-events: auto;
    visibility: ${p => p.isHide ? 'hidden' : 'visible'};
    :before {
        content: '';
        position: absolute;
        width: 17px;
        height: 17px;
        top: 50%;
        left: 50%;
        border-right: 2px solid ${COLORS.red};
        border-bottom: 2px solid ${COLORS.red};
        border-radius: 1px;
        transform-origin: center;
        transform: translate(-70%, -50%) rotate(-45deg);
   }
`;

export const SliderWrapper = styled.div`
    overflow: visible;
    width: calc(100% + 20px);
    margin: 0 -10px;
    @media(max-width: 1279px) {
        width: calc(100% + 10px);
        margin: 0 -5px;
    }
    @media(max-width: 767px) {
        max-width: 370px;
        margin-bottom: 48px;
    }
`;

export const Slide = styled.div`
    display: block;
    width: calc(100% - 20px);
    margin: 0;
    max-width: 400px;
    @media(max-width: 1279px) {
        width: calc(100% - 10px);
    }
`;

export const FlexBoxRowSlider = styled(FlexBoxRow)`
    min-width: 100%;
`;

export const CustomCarousel = styled(Carousel)`
    & > div:first-child > div {
        @media (max-width: 767px) {
            touch-action: auto;
            pointer-events: initial;
            & > div {
                width: auto !important;
            }
        }
    }
`;
